import React from 'react';
import { Label } from 'react-bootstrap'

class DD214StatusLabel extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value
            || nextProps.dependentValues !== this.props.dependentValues);
	}

	render() {
        let bg = 'transparent';
        let type = '#000000';
        let labelContent = "";
        let fileUploaded = this.props.value;
        
        if (fileUploaded)
        {
            if (this.props.dependentValues.caReviewValidDocument === true && 
                this.props.dependentValues.mgmtReviewValidDocument === true)
            {
                // Green
                bg = '#43d162';
                labelContent = "VETERAN";
            }
            else if (this.props.dependentValues.caReviewValidDocument === false && 
                     this.props.dependentValues.mgmtReviewValidDocument === false)
            {
                // Red
                bg = '#ba1111';
				type = '#FFFFFF';
                labelContent = "SVCMEM";
            }
            else if ((this.props.dependentValues.caReviewValidDocument === false && 
                      this.props.dependentValues.mgmtReviewValidDocument === true) || 
                     (this.props.dependentValues.caReviewValidDocument === true && 
                      this.props.dependentValues.mgmtReviewValidDocument === false))
            {
                // Yellow
                bg = 'yellow';
                labelContent = "CONFLICT";
            }
            else if (this.props.dependentValues.caReviewValidDocument === null && 
                this.props.dependentValues.mgmtReviewValidDocument === null)
            {
                // Grey
                bg = '#d2d6de'; 
                labelContent = "PENDING";
            }
            else
            {
                // Orange
                bg = 'orange';
                labelContent = "PENDING";
            }
        }
		else
		{
            labelContent = this.props.emptyLabel;
		}

        let style = {
            backgroundColor: bg,
            color: type,
            display: "block",
            position: "relative",
            width: "100%",
            height: "34px",
            paddingTop: "10px",
            margin: "0",
            padding: "0"
        };
        
        if (this.props.labelFormat)
            return (
                <Label style={{ color:type, backgroundColor:bg, height: "34px" }}>
                    <span>{labelContent}</span>
                </Label>);
        else
            return (
                <React.Fragment>
                    <Label style={style}>
                        <span style={{ display: "block", paddingTop: "12px" }}>{labelContent}</span>
                    </Label>
                </React.Fragment>);
	}
}

export default DD214StatusLabel;

DD214StatusLabel.defaultProps = {
	emptyLabel: "EMPTY",
    labelFormat: false
};


// WEBPACK FOOTER //
// ./src/areas/admin/shared/DD214StatusLabel.js